import { Navigate, useLocation, Outlet } from 'react-router-dom'

/* Route-guard: geen auth_token → naar /login met de bedoelde bestemming in
   de URL, zodat je na inloggen terugkomt waar je naartoe wilde.
   Dit is een frontend-guard; de echte beveiliging blijft de backend. */
export default function RequireAuth() {
  const heeftToken = typeof window !== 'undefined' && !!localStorage.getItem('auth_token')
  const location = useLocation()

  if (!heeftToken) {
    return <Navigate to="/login" replace state={{ from: location.pathname + location.search }} />
  }
  return <Outlet />
}
